import React from 'react'
import { Flex } from '@chakra-ui/core'
import { Star } from 'lucide-react'

interface RatingStarsProps {
  rating: number
  size?: 'small' | 'medium'
  maxRating?: number
}

export const RatingStars: React.FC<RatingStarsProps> = ({ rating, size = 'medium', maxRating = 5 }) => {
  const starSize = size === 'small' ? 14 : 16

  return (
    <Flex alignItems="center" style={{ gap: '2px' }}>
      {Array.from({ length: maxRating }, (_, i) => i + 1).map((star) => (
        <Star
          key={star}
          size={starSize}
          fill={star <= rating ? '#FBBF24' : 'none'}
          stroke={star <= rating ? '#FBBF24' : '#D1D5DB'}
          strokeWidth={star <= rating ? 0 : 1.5}
        />
      ))}
    </Flex>
  )
}
